<template>
<!-- <tr>
    <td class="TORDes">
    {{this.operazione.Descrizione}}
    </td>
    <td class="TORNot">
    <span>Note</span>
    <form class="Form TableForm">
        <div class="FormRow">
        <div class="FormBox66">
            <input type="text" id="" name="" placeholder="Aggiungi nota" v-model="this.noteOperazione"/>
        </div>
        <div class="FormBox33">
            <div class="TwinButtons Min">
            <div class="Button ExtraSmall">
                <input type="button" id="" name=""  value="Salva nota" @click="this.updateOperazione(1, 0, 0)" />
            </div>
            <div class="Button ExtraSmall">
                <input type="button" id="" name="" value="Annulla" @click="this.noteOperazione=''" />               
            </div>
            </div>
        </div>
        </div>
    </form>
    </td>
    <td class="TORSel">
    <span>Esito</span>
    <form class="Form">
        <div class="FormRow">
        <div class="FormBox66">
            <select class="CustomSelect" name="siti" :id="'selectEsito'+this.index">            
            <option value="">Scegli l'esito</option>
            <option  v-for="esito in this.$store.getters.getEsitiOperazioni" :key="esito.Codice" :value="esito.Codice">{{ esito.Descrizione }}</option>                                 
            </select>
        </div>
        <div class="FormBox33">
            <div class="Button ExtraSmall Stroked">
                <input type="button" id="" name="" value="Conferma" @click="this.updateOperazione(0, 1, 0)"/>
                <input type="text" id="esitoSelected" style="display:none;">
            </div>
        </div>
        </div>
    </form>
    </td>
    <td class="TORChe">
    <span>Eseguito</span>
    <form class="Form">
        <div class="FormRow">
        <div class="FormBoxWide">
            <div class="FormCheckBox">
            <div class="CheckField">
                <input type="checkbox" name="" @click="this.updateOperazione(0, 0, 1)" :checked="this.operazione.Eseguito" /><span class="Checkmark"></span>
            </div>
            <div class="CheckLabel">&nbsp;</div>
            </div>
        </div>
        </div>
    </form>
    </td>
</tr> -->
<!-- Inizio repeater repeater repeater -->
<tr>
    <td class="TORDes">
        <span>Descrizione operazione</span>
        {{this.operazione.Descrizione}}
    </td>
    <td class="TORNot">
        <span>Note</span>       
        {{this.operazione.Note}}

    </td>
    <td class="TORSel">
        <span>Esito</span>
        {{ this.$store.getters.getDescrizioneEsito(this.operazione.CodiceEsito) }}
    </td>
</tr>
<!-- Fine repeater repeater repeater -->
</template>

<script>

export default {
    name: "OperazioneRigaStorico",
    props: {
        operazione: Object,
        index: Number
    }
}
</script>